import React, {useCallback, useLayoutEffect} from 'react'

import {PageContentInterface} from "../page-content-interface"
import AttachmentsCollection from "../../../../../core/model2/attachment/attachments"
import PageControls from "../controls/controls"
import {useForceUpdate} from "../../../../../core/gd/utils/dom-and-react/react-utils"
import HeaderAppTitleNew from "../../../../../layout/top/header/common/app-title/app-title-new"
import ApiDocument from "../../../../../core/gd/api/document"

type Props = {
    className?      : string

    app             : PageContentInterface
    attachments?    : AttachmentsCollection

    onAddPage       : func
}

export const PAGE_NAME_CHANGED = 'page:name-changed'

export default function PageTitle(props: Props) {

    const titleStyle : style = {
        marginLeft  : '12px',
    }

    const forceUpdate = useForceUpdate()

    useLayoutEffect(() => {
        return gd.bus.subscribeNoContext(PAGE_NAME_CHANGED, onNameChanged)
    }, [props.app.document])

    const onNameChanged = useCallback((name: string) => {
        props.app.document.name = name
        forceUpdate()
    }, [])

    const onChange = (title: string) => {
        if (props.app.document.pages.length > 1) {
            const page = props.app.document.pages.getPage(props.app.currentPageId)!
            page.title = title
            props.app.document.save()
            props.app.reRender()
        } else {
            props.app.document.name = title
            ApiDocument.update(props.app.document.id, {name: title})
        }

        forceUpdate()
    }

    const getName = () => {
        if (props.app.document.pages.length > 1) {
            return props.app.document.pages.getPage(props.app.currentPageId)?.title!
        } else {
            return props.app.document.name
        }
    }

    const canEdit       = !gd.isSharedView && props.app.project.acl.hasFullAccess
    const showControls  = !gd.isSharedView

    const classes = Classes("page-title-container p-t-70", props.className)

    return (
        <div className={classes}>
            {showControls &&
                <PageControls app           = {props.app}
                              attachments   = {props.attachments}
                              onAddPage     = {props.onAddPage}/>}

            <div className="page-title flex-row-left-center">
                <HeaderAppTitleNew style    = {titleStyle}
                                   name     = {getName()}
                                   maxWidth = {600}
                                   editable = {canEdit}
                                   onChange = {onChange}/>
            </div>
        </div>
    )
}
